import Big from 'big.js';
import { Box } from '@ff-it/ui';
import type { ReactNode } from 'react';

export function DeltaBadge({
  planned,
  target,
  testId,
}: {
  planned: string;
  target: string;
  testId: string;
}): ReactNode {
  const diff = new Big(planned).minus(target);
  if (diff.eq(0)) {
    return null;
  }

  let value: Big;
  let label: string;
  if (new Big(target).eq(0)) {
    value = diff;
    label = diff.abs().toFixed(2);
  } else {
    value = diff.div(target).times(100);
    const abs = value.abs();
    // Anything under 0.1% collapses to a compact marker to save space; planned value is in the tooltip.
    label = abs.lt('0.1') ? '≈0%' : `${abs.toFixed(1).replace(/\.0$/, '')}%`;
  }

  const positive = value.gt(0);
  label = `${positive ? '+' : '-'}${label}`;

  return (
    <Box
      as="span"
      testId={testId}
      fontSize="xxs"
      lineHeight="xxs"
      fontWeight="regular"
      background={positive ? 'success50' : 'error50'}
      color={positive ? 'success800' : 'error800'}
      title={planned}
    >
      {label}
    </Box>
  );
}
